import { ROLES as R } from "../core/roles";
import { everyoneBut, lud, rule } from "../core/rule";
import { SCOPES } from "../core/scope";

export const notificationPermissions = {
  view: "notification.view",
  nav: "notification.nav",
  send: "notification.send",
  readMark: "notification.read.mark",
  templateManage: "notification.template.manage",
  inboxFilters: "notification.inbox.filters",
  template: { menuGroup: "notification.template.menuGroup", reportGroup: "notification.template.reportGroup" },
};

export const notificationGrants = {
  "notification.view": rule([...everyoneBut(), R.NEW]),
  // sidebar entry (fa and feedus have no entry but can open the URL)
  "notification.nav": rule(lud(R.BRANCH, R.MENU_SP, R.DM, R.DMM, R.AM, R.SALES, R.STORE_L, R.STORE, R.NEW)),
  // tabs / composer: not for restaurants and branches. Each recipient restaurant
  // (`scope.ownerId`, a public id found in the restaurants list) must be in scope (NA-011).
  "notification.send": rule(everyoneBut(R.STORE, R.STORE_L, R.BRANCH), { scope: SCOPES.RESTAURANT }),
  // Marking a notification read (NA-010): everyone who can open the inbox, but only for a
  // notification that belongs to a restaurant they reach (`notification.scope.ownerId`).
  // This adds no new role: it only names the check the handler runs.
  "notification.read.mark": rule([...everyoneBut(), R.NEW], { scope: SCOPES.RESTAURANT }),
  "notification.template.manage": rule(lud(R.AM, R.DMM)),
  // category chips: not for restaurants
  "notification.inbox.filters": rule(everyoneBut(R.STORE, R.STORE_L)),
  // which template group is shown by default when composing
  "notification.template.menuGroup": rule([R.MENU_SP]),
  "notification.template.reportGroup": rule([R.DM]),
};
